import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  ApplicationMeasureDetails,
} from '@ms-organization-entities';
import {PriorityPatchRequest} from '@primatoo-ms-organization';
import {ApiClientConfig} from '../api-client-config';
import {DataProtectionGovernanceService} from '../interface/data-protection-governance-service';
import {ColumnWithLocalization} from "it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization";
import { ApplicationMeasure } from 'it/primatoo/openapi/api/org/schemas/applicationmeasure/ApplicationMeasure';
import {
  ApplicationMeasureDependency
} from '@primatoo-ms-organization';
import {
  CreateApplicationMeasureRequest
} from 'it/primatoo/openapi/api/org/schemas/applicationmeasure/CreateApplicationMeasureRequest';
import { CreateResponse } from 'it/primatoo/openapi/api/common/schemas/CreateResponse';
import {
  UpdateApplicationMeasureRequest
} from 'it/primatoo/openapi/api/org/schemas/applicationmeasure/UpdateApplicationMeasureRequest';

@Injectable({
  providedIn: 'root'
})
export class TechnicalMeasureService extends DataProtectionGovernanceService {
  private readonly endpoint: string;
  private readonly endpointV2: string;

  constructor(
    @Inject(ApiClientConfig) protected config: ApiClientConfig,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/application-measures/';
    this.endpointV2 = this.config.endPoint + '/api/org/v2/application-measures/';

  }

  public setPriority(id: number, request: PriorityPatchRequest): Observable<ApplicationMeasure> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<ApplicationMeasure>(url, request);
  }

  public getTechnicalMeasures(): Observable<ApplicationMeasure[]> {
    const url = this.endpoint;
    return this.httpClient.get<ApplicationMeasure[]>(url);
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  public getApplicationMeasureById(id: number): Observable<ApplicationMeasure> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<ApplicationMeasure>(url);
  }

  public getApplicationMeasureDetails(id: number): Observable<ApplicationMeasureDetails> {
    const url = this.endpoint + id + '/details';
    return this.httpClient.get<ApplicationMeasureDetails>(url);
  }

  public getApplicationMeasureDependency(id: number): Observable<ApplicationMeasureDependency> {
    const url = this.endpoint + id + '/dependency';
    return this.httpClient.get<ApplicationMeasureDependency>(url);
  }

  public create(requestBody: CreateApplicationMeasureRequest): Observable<CreateResponse> {
    return this.httpClient.post<CreateResponse>(this.endpointV2, requestBody);
  }

  public update(id: number, requestBody: UpdateApplicationMeasureRequest): Observable<void> {
    const url = this.endpointV2 + id + '/';
    return this.httpClient.put<void>(url, requestBody);
  }

  public getEndPointV1(): string {
    return this.endpoint;
  }
}
